import script from "./DampGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./DampGroup.vue?vue&type=script&setup=true&lang=js"

import "./DampGroup.vue?vue&type=style&index=0&id=f340ec8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f340ec8e"]])

export default __exports__